import { isObject, isNil, filter, map, differenceBy, forEach } from 'lodash';
import { mapState } from 'vuex';

const matrixColSourcedMixin = {

    props: {
        source: String,
        filter: [String, Object],
    },

    computed: {
        tableClass()
        {
            return `-count-${this.cols.length}`;
        },

        ...mapState({
            cols(state)
            {
                if (isNil(this.filter))
                {
                    return state[this.source];
                }
                return filter(state[this.source], this.filter);
            },
        }),
    },

    mounted()
    {
        this.$watch('cols', (newVals, oldVals) =>
        {
            if (newVals.length < oldVals.length)
            {
                // Remove deleted cols in answer
                if (isObject(this.answer.answer))
                {
                    setTimeout(() =>
                    {
                        const removedColIDs = map(differenceBy(oldVals, newVals, 'id'), 'id');
                        this.$store.dispatch('REMOVE_COLUMNS', [this.uukey, removedColIDs]);
                    }, 250);
                }
            }
        });
    },

};

export { matrixColSourcedMixin }



// WEBPACK FOOTER //
// ./resources/assets/js/components/vue/mixins/matrix-col-sourced-mixin.js